import { useTranslation } from 'react-i18next'
import {
  TitleLeft,
  ContainerHeader,
  ContainerTable,
  DivRight,
  IconLeftOutlined,
  SpanNotYetReleased,
} from '../../styled'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ButtonSave, StyleButtonClose } from '../../../TaxDeduction/styled'
import { LeftOutlined } from '@ant-design/icons'
function HeaderTaxDectionDocumentsUpdate(
  {
    setOpenModalAlert,
    setOpenModalAlertTemplate,
    onClickSaveAndSign,
    setOpenModalMaintenance,
    openModalAlertTemplateSave,
    setOpenModalAlertTemplateSave,
    nameTemplate,
    saveSign,
  },
  props,
) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  //   useEffect(() => {

  //   }, [dataSource])

  return (
    <>
      <ContainerHeader>
        <div className="row">
          <TitleLeft className="col-sm-8">
            <IconLeftOutlined
              onClick={() => {
                navigate('/hoa-don-dau-ra/chung-tu-tncn/thiet-lap/mau')
              }}
            />
            {nameTemplate}
            <SpanNotYetReleased>
              {t('taxDeductionDocuments.notYetReleased')}
            </SpanNotYetReleased>
          </TitleLeft>
          <div className="col-sm-4">
            <DivRight>
              <StyleButtonClose
                onClick={() => {
                  setOpenModalAlert(true)
                }}
              >
                {t('taxDeductionDocuments.cancel')}
              </StyleButtonClose>
              <StyleButtonClose
                onClick={() => {
                  setOpenModalAlertTemplate(true)
                }}
              >
                {t('taxDeductionDocuments.templateDefault')}
              </StyleButtonClose>
              <StyleButtonClose
                onClick={() => {
                  setOpenModalAlertTemplateSave(true)
                }}
              >
                {t('taxDeductionDocuments.save')}
              </StyleButtonClose>
              <ButtonSave
                type="primary"
                onClick={() => {
                  saveSign()
                }}
              >
                {t('taxDeductionDocuments.saveAndSign')}
              </ButtonSave>
            </DivRight>
          </div>
        </div>
        <TitleLeft></TitleLeft>
      </ContainerHeader>
    </>
  )
}
export default HeaderTaxDectionDocumentsUpdate
